import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import AffiliateConfig from '../../types/affiliate/affiliate-config'

@Module(
  {
    name: 'Affiliate'
  }
)
export default class Affiliate extends VuexModule {
  // #region Host name eg Carcraft

    host = '';

    @Mutation
    private setHost (val: string) {
      this.host = val
    }

    @Action
    updateHost (val: string) {
      this.setHost(val)
    }

    // #endregion

    // #region Sub Domain

    subDomain: string | null = null;

    @Mutation
    private setSubDomain (val: string | null) {
      this.subDomain = val
    }

    @Action
    updateSubDomain (val: string | null) {
      this.setSubDomain(val)
    }

    // #endregion

    // #region Affiliate Config

    affiliateConfig: AffiliateConfig | null = null;

    @Mutation
    private setAffiliateConfig (val: AffiliateConfig | null) {
      this.affiliateConfig = val
    }

    @Action
    updateAffiliateConfig (val: AffiliateConfig | null) {
      this.setAffiliateConfig(val)
    }

    // #endregion

    // #region Affiliate Config

    affiliateUserID: string | null = null;

    @Mutation
    private setAffiliateUserID (val: string | null) {
      this.affiliateUserID = val
    }

    @Action
    updateAffiliateUserID (val: string | null) {
      this.setAffiliateUserID(val)
    }

    // #endregion

    // #region Referrer URL

    referrerURL: string | null = null;

    @Mutation
    private setReferrerURL (val: string | null) {
      this.referrerURL = val
    }

    @Action
    updateReferrerURL (val: string | null) {
      this.setReferrerURL(val)
    }

  // #endregion
}
